const Logo = ({ size = 40 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Crochet Els yarn ball logo"
    data-testid="crochet-els-logo"
  >
    <circle cx="30" cy="34" r="20" fill="#8AA387" />
    <path
      d="M13 28c6-5 28-6 34 1M11 36c8-6 30-7 38 0M14 44c7-5 25-6 32-1M22 17c-2 9-2 24 2 34M38 17c2 9 2 24-2 34"
      stroke="#F9F6F0"
      strokeWidth="2.4"
      strokeLinecap="round"
      fill="none"
    />
    <path
      d="M48 42c8 4 10 10 6 14"
      stroke="#C27F67"
      strokeWidth="2.6"
      strokeLinecap="round"
      fill="none"
    />
    <circle cx="53" cy="57" r="2.4" fill="#C27F67" />
  </svg>
);

export default Logo;
